/**
 * Đủ thông tin xuất hoá đơn của khách hàng (30/10/2026): Mã số thuế, Tên đầy đủ, Địa chỉ, Email nhận hoá đơn.
 * Trước đây chỉ xét MST + địa chỉ, và nhãn "Đủ thông tin xuất HĐ" hiện cả khi còn thiếu.
 */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export interface CustomerInvoiceFields {
  name?: string | null;
  taxCode?: string | null;
  address?: string | null;
  email?: string | null;
}

/** Danh sách trường còn thiếu để xuất hoá đơn (rỗng = đủ) */
export function customerInvoiceMissing(c: CustomerInvoiceFields | null | undefined): string[] {
  const missing: string[] = [];
  if (!c?.taxCode?.trim()) missing.push("Mã số thuế");
  if (!c?.name?.trim()) missing.push("Tên đầy đủ");
  if (!c?.address?.trim()) missing.push("Địa chỉ");
  const email = c?.email?.trim() || "";
  if (!email) missing.push("Email nhận hoá đơn");
  else if (!EMAIL_RE.test(email)) missing.push("Email nhận hoá đơn hợp lệ");
  return missing;
}
